module.exports = __webpack_public_path__ + "img/labmem_text_share_tc.5be14c98.png";